import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useSiteSettings } from "./SiteSettingsContext";

const I18nContext = createContext(null);

const STRINGS = {
    ar: {
        nav_home: "الرئيسية",
        nav_about: "عن ليجيندز",
        nav_welcome: "كلمة الترحيب",
        nav_services: "الخدمات",
        nav_works: "أعمالنا",
        nav_news: "الأخبار",
        nav_global: "الوصول العالمي",
        nav_clients: "عملاؤنا",
        nav_contact: "تواصل معنا",
        nav_admin: "لوحة التحكم",
        cta_explore: "استكشف أعمالنا",
        cta_company_profile: "الملف التعريفي",
        cta_view_case: "اطّلع على الحالة",
        cta_read_more: "اقرأ المزيد",
        cta_view_all: "عرض الكل",
        cta_contact: "ابدأ مشروعك",
        cta_explore_more: "استكشف المزيد",
        tagline_overline: "علاقات عامة · اتصال استراتيجي · الرياض",
        tagline: ".رؤى. تأثير .إرث",
        hero_sub: "نُحوّل العلامات التجارية والقيادات إلى أساطير عبر سرديات مدروسة وعلاقات إعلامية عالمية",
        section_about_overline: "عن ليجيندز",
        section_about_title: "مسار أسطوري",
        section_about_body: "تأسسـت ليجنـدز بـي آر فـي عـام 2019 بمدينـة الريـاض، المملكـة ً العربيــة الســعودية، ومنــذ ذلــك الحــين وهــي تصــنع تــأثيرا محليــا وعالميــا 2030 ّ ومــا بعــدها، ممــا يمكــن ً بمــا يتماشــى مــع رؤيــة ّ العلامات التجاريـة والمؤسسـات مـن التقـدم إلـى الصـدارة بصـوت قوي ومؤثر. ومـن خـلال خبرتهـا العميقـة فـي السـوق المحلـي وشـبكة علا",
        section_numbers_overline: "شبكتنا · بالأرقام",
        section_numbers_title: "حضور محلي ونفوذ عالمي",
        section_global_overline: "حضورنا العالمي",
        section_global_title: "وصول يتخطى الحدود",
        section_global_sub: "شبكة من الشركاء والمنصات الإعلامية تمتد عبر القارّات، مع ثقل في كل القارات تربطنا بأهم صنّاع القرار حول العالم.",
        section_services_overline: "الخدمات",
        section_services_title: "خدمات متكاملة لصياغة الأثر",
        section_works_overline: "أعمالنا",
        section_works_title: "حالات نوعية وسرديات تترك أثراً",
        section_news_overline: "آخر الأخبار",
        section_news_title: "ما يجري في ليجيندز",
        section_clients_overline: "عملاؤنا وشركاؤنا",
        section_clients_title: "ثقة جهات نوعية محلياً وعالمياً",
        section_contact_overline: "تواصل معنا",
        section_contact_title: "لنصنع إرثاً معاً",
        contact_name: "الاسم",
        contact_email: "البريد الإلكتروني",
        contact_company: "الجهة / الشركة",
        contact_subject: "الموضوع",
        contact_message: "تفاصيل المشروع",
        contact_send: "إرسال الرسالة",
        contact_success: "شكراً لتواصلك. سنرد عليك قريباً.",
        works_filter_all: "كل التصنيفات",
        login_title: "تسجيل دخول الإدارة",
        login_email: "البريد الإلكتروني",
        login_password: "كلمة المرور",
        login_submit: "تسجيل الدخول",
        admin_dashboard: "لوحة التحكم",
        admin_site_settings: "إعدادات الموقع",
        admin_works: "الأعمال",
        admin_news: "الأخبار",
        admin_services: "الخدمات",
        admin_values: "قيمنا",
        admin_stats: "أرقام الشبكة",
        admin_media: "مكتبة الوسائط",
        admin_clients: "العملاء",
        admin_business_cards: "بطاقات العمل",
        admin_global: "الوصول العالمي",
        admin_users: "المستخدمون",
        admin_profile: "ملف الشركة",
        admin_welcome: "كلمة الترحيب",
        admin_contacts: "الرسائل",
        admin_logout: "تسجيل الخروج",
        download_profile: "تحميل الملف التعريفي PDF",
        category_label: "التصنيف",
        client_label: "العميل",
        city_label: "المدينة",
        year_label: "السنة",
        objective: "الهدف",
        challenge: "التحدي",
        methodology: "منهجية العمل",
        achievements: "الإنجازات",
        results: "الإنجازات",
        not_found: "العنصر غير موجود",
        rights: "جميع الحقوق محفوظة",
    },
    en: {
        nav_home: "Home",
        nav_about: "About",
        nav_welcome: "Welcome",
        nav_services: "Services",
        nav_works: "Work",
        nav_news: "News",
        nav_global: "Global Reach",
        nav_clients: "Clients",
        nav_contact: "Contact",
        nav_admin: "Admin",
        cta_explore: "Explore Our Work",
        cta_company_profile: "Company Profile",
        cta_view_case: "View Case Study",
        cta_read_more: "Read more",
        cta_view_all: "View all",
        cta_contact: "Start your project",
        cta_explore_more: "Explore more",
        tagline_overline: "Public Relations · Strategic Communication · Riyadh",
        tagline: "Insights. Influence. Legacy.",
        hero_sub: "We turn brands and leaders into Legends through deliberate narratives and global media relations",
        section_about_overline: "About Legends",
        section_about_title: "A Legendary Path",
        section_about_body: "Founded in 2019 in Riyadh, KSA, Legends has been creating impact locally and globally in alignment with Vision 2030 and beyond, enabling brands and organisations to step to the forefront with an amplified, powerful voice. By leveraging its deep local expertise and a unique network of connections worldwide, Legends bridges cultures with trust, integrity, and passion beyond compare, infusing these into each of its broad range of PR and Communication services.",
        section_numbers_overline: "Network · By the numbers",
        section_numbers_title: "Local presence and global influence",
        section_global_overline: "Our Global Presence",
        section_global_title: "Reaching beyond borders",
        section_global_sub: "A network of partners and media outlets spanning continents, with strong presence across every region connecting us to the world's most influential decision-makers.",
        section_services_overline: "Services",
        section_services_title: "Services crafting impact",
        section_works_overline: "Our Work",
        section_works_title: "Signature cases and lasting narratives",
        section_news_overline: "Latest News",
        section_news_title: "What's new at Legends",
        section_clients_overline: "Clients & Partners",
        section_clients_title: "Trusted locally and globally",
        section_contact_overline: "Contact Us",
        section_contact_title: "Let's build a legacy together",
        contact_name: "Name",
        contact_email: "Email",
        contact_company: "Company / Entity",
        contact_subject: "Subject",
        contact_message: "Project details",
        contact_send: "Send Message",
        contact_success: "Thanks for reaching out. We'll be in touch soon.",
        works_filter_all: "All Categories",
        login_title: "Admin Sign In",
        login_email: "Email",
        login_password: "Password",
        login_submit: "Sign in",
        admin_dashboard: "Dashboard",
        admin_site_settings: "Site Settings",
        admin_works: "Works",
        admin_news: "News",
        admin_services: "Services",
        admin_values: "Values",
        admin_stats: "Network Stats",
        admin_media: "Media Library",
        admin_clients: "Clients",
        admin_business_cards: "Business Cards",
        admin_global: "Global Reach",
        admin_users: "Users",
        admin_profile: "Company Profile",
        admin_welcome: "Welcome Page",
        admin_contacts: "Messages",
        admin_logout: "Logout",
        download_profile: "Download Company Profile PDF",
        category_label: "Category",
        client_label: "Client",
        city_label: "City",
        year_label: "Year",
        objective: "Objective",
        challenge: "Challenge",
        methodology: "Methodology",
        achievements: "Achievements",
        results: "Achievements",
        not_found: "Item not found",
        rights: "All rights reserved",
    },
};

export function I18nProvider({ children }) {
    // Default to English on every fresh visit. Within a session, the user's
    // language choice persists (sessionStorage), but a new tab / new visit
    // always starts in English as the brand-default experience.
    const [lang, setLang] = useState(() => sessionStorage.getItem("legends_lang") || "en");
    const { settings } = useSiteSettings();

    useEffect(() => {
        const html = document.documentElement;
        html.lang = lang;
        html.dir = lang === "ar" ? "rtl" : "ltr";
        sessionStorage.setItem("legends_lang", lang);
    }, [lang]);

    const t = useCallback((key) => {
        const editableValue = settings?.[`${key}_${lang}`];
        if (typeof editableValue === "string" && editableValue.trim()) return editableValue;
        return STRINGS[lang]?.[key] ?? key;
    }, [lang, settings]);
    const pick = useCallback((obj, base) => {
        if (!obj) return "";
        return obj[`${base}_${lang}`] ?? obj[`${base}_en`] ?? obj[base] ?? "";
    }, [lang]);

    const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);

    return (
        <I18nContext.Provider value={{ lang, setLang, toggle, t, pick, isRTL: lang === "ar" }}>
            {children}
        </I18nContext.Provider>
    );
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be inside I18nProvider");
    return ctx;
}
